import { useState } from 'react';
import { SITE } from '../data/site';
import { BILLING, PLANS, fmtPrice } from '../data/pricing';
import { Icon } from '../components/Icon';
import { PayBadges } from '../components/PayBadges';
import './PlanPicker.css';

// Compact checkout: pick a row, press one button. Short enough to fit a phone screen without scrolling.
// The button names the plan only; the price is in the row right above it.
export function PlanPicker({ plans = PLANS, busy = false, onBuy, cta = (p) => `Get ${p.name}` }) {
    const [tier, setTier] = useState(() => (plans.find((p) => p.popular) || plans[0]).tier);
    const selected = plans.find((p) => p.tier === tier) || plans[0];

    return (
        <div className="planPick">
            <div className="planRows" role="radiogroup" aria-label="Plan">
                {plans.map((p) => {
                    const on = p.tier === selected.tier;
                    return (
                        <button
                            key={p.tier}
                            type="button"
                            role="radio"
                            aria-checked={on}
                            className={`planRow${on ? ' isOn' : ''}`}
                            onClick={() => setTier(p.tier)}
                        >
                            {p.badge && <span className="planRowBadge">{p.badge}</span>}
                            <span className="planRadio">{on && <Icon name="check" size={12} strokeWidth={3.4} />}</span>
                            <span className="planRowMain">
                                <b>{p.name}</b>
                                <span>{p.summary}</span>
                            </span>
                            <span className="planRowPrice">
                                <b>{fmtPrice(p.price)}<i>{BILLING.short}</i></b>
                                {p.strike && <s>{fmtPrice(p.strike)}</s>}
                            </span>
                        </button>
                    );
                })}
            </div>

            <button type="button" className="btn btn--primary btn--lg btn--block" onClick={() => onBuy(selected.tier)} disabled={busy}>
                {busy ? 'Redirecting…' : cta(selected)}
            </button>

            <PayBadges />

            <p className="planFoot">
                <Icon name="lock" size={12} /> Cancel anytime · Secure checkout via {SITE.checkoutProvider}
            </p>
        </div>
    );
}
